import React, { ReactNode } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Statistic = ({
  icon,
  title,
  children,
}: {
  icon: IconDefinition;
  title: string;
  children: ReactNode;
}) => {
  return (
    <div className="rounded-lg bg-white text-gray-800 bg-opacity-50 text-center py-2 px-5 mr-2 mb-2 shadow-md">
      <div className="text-2xl text-gray-500">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className="text-xs">{title}</div>
      <span className="text-xl font-bold">{children}</span>
    </div>
  );
};
